var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEraser = function SvgEraser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eraser_svg__\\uB808\\uC774\\uC5B4_1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".eraser_svg__st1{fill:none}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 2,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M1 21.95h22"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "eraser_svg__st1",
    d: "m14.02 19.01-8.08-8.08-4.04 4.04 6.98 6.98h2.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "eraser_svg__st1",
    d: "M11.08 21.95h-2.2l1.1 1.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "eraser_svg__st2",
    d: "M23.44 12.28c.74-.74.74-1.95 0-2.69l-8.08-8.08c-.74-.74-1.95-.74-2.69 0L5.94 8.24.56 13.62c-.74.74-.74 1.95 0 2.69l5.63 5.63h2.69L1.9 14.96l4.04-4.04L14.02 19l-2.94 2.94h2.69L16.71 19l6.73-6.72z"
  })));
};
export default SvgEraser;